import {
  ToolkitProperty,
  addressToMultilineAddress,
  expected,
  getBathsString,
  isDefined,
} from '@aloft/toolkit-shared';

import { PropertyTooltip, PropertyTooltipProps } from '../../../../components/PropertyTooltip.tsx';
import { PLACEHOLDER } from '../../../../components/ToolkitPropertyTable/constants.ts';
import MapBox from '../../../../components/map/MapBox.ts';
import { MapPopup } from './MapPopup.tsx';

const propertyTooltipPropsFromToolkitProperty = (
  property: ToolkitProperty,
): PropertyTooltipProps => {
  const { closeDate, salePrice, listPrice } = property;

  const isSold =
    property.listingStatus === 'SettledSale' && isDefined(salePrice) && isDefined(closeDate);

  const beds = property.aboveGradeBedroomCount?.toString() ?? PLACEHOLDER;
  const baths = getBathsString(property);

  const gla = property.grossLivingArea?.toSqFtValueStringRounded() ?? PLACEHOLDER;

  const photoUrl = property.images?.[0]?.url;

  const addressParts = addressToMultilineAddress(expected(property.address));

  return { isSold, beds, baths, gla, photoUrl, addressParts, closeDate, salePrice, listPrice };
};

type PairedSalesMapPropertyTooltipProps = {
  property?: ToolkitProperty;
  onTooltipClose: () => void;
  mapRef: React.MutableRefObject<MapBox | null>;
};

export const PairedSalesMapPropertyTooltip = ({
  property,
  onTooltipClose,
  mapRef,
}: PairedSalesMapPropertyTooltipProps) => {
  if (!property) return null;

  return (
    <MapPopup
      map={mapRef.current?.getMap()}
      lat={expected(property.latitude)}
      lng={expected(property.longitude)}
      onClose={onTooltipClose}
    >
      <PropertyTooltip {...propertyTooltipPropsFromToolkitProperty(property)} />
    </MapPopup>
  );
};
